// import gl from '../lib/gallery_lib';
export default class FolderManager {
  constructor(el) {
    // this.el = el;
    // this.moduleName = this.el.getAttribute('data-module-name');
    // this.itemsSelector = this.el.getAttribute('data-items-selector');
    // this.maxCharsWrapper = this.el.querySelector('#msg-max-chars-wrapper');
    // this.errorMaxChars = this.maxCharsWrapper.innerHTML;
    // this.allovedCharsWrapper = this.el.querySelector(
    //   '#msg-alloved-chars-wrapper'
    // );
    // this.errorAllovedChars = this.allovedCharsWrapper.innerHTML;
    // this.deleteMessageWrapper = this.el.querySelector(
    //   '#msg-delete-message-wrapper'
    // );
    // this.deleteMessage = this.deleteMessageWrapper.innerHTML;
    // this.items = this.el.querySelectorAll(this.itemsSelector);
    // this.submitSelector = this.el.getAttribute('data-submit-selector');
    // this.createFolderButton = this.el.querySelectorAll(this.submitSelector);
    // this.init();
  }

  /* eslint-disable class-methods-use-this */
  init() {
    this.createFolderButton.forEach(createBtn => {
      createBtn.addEventListener('click', () => {
        const inField = this.el.querySelector('input[name="foldername"]');
        this.createFolder(0, inField.value);
      });
    });

    this.items.forEach(item => {
      const id = item.getAttribute('data-item-id');
      // const name = item.getAttribute('data-item-name');
      const nameWrapper = item.querySelector('.name-wrapper');
      const nameWrapperText = nameWrapper.querySelector('span');
      const editBtn = item.querySelector('.edit-btn');
      const saveBtn = item.querySelector('.save-btn');
      const deleteBtn = item.querySelector('.delete-btn');
      // const deleteConfirmBtn = item.querySelector('.delete-confirm-btn');
      const cancelBtn = item.querySelector('.cancel-btn');
      const msgBox = item.querySelector(`#message-${id}`);
      const actionsWrapper = item.querySelector('.action-element-wrapper');
      const inputName = actionsWrapper.querySelector(
        `input[name="item_name[${id}]"]`
      );
      const inputNameCurrent = actionsWrapper.querySelector(
        `input[name="item_name_current[${id}]"]`
      );

      editBtn.addEventListener('click', () => {
        this.implaceEdit('show', editBtn, nameWrapper, actionsWrapper);
      });

      saveBtn.addEventListener('click', () => {
        const newValue = inputName.value.trim();
        const result = this.save(id, newValue);
        if (result.error === 0) {
          this.implaceEdit('hide', editBtn, nameWrapper, actionsWrapper);
          item.setAttribute('data-item-name', newValue);
          nameWrapperText.innerText = newValue;
          inputNameCurrent.value = newValue;
          msgBox.classList.add('hidden');
          msgBox.innerHTML = '';
          deleteBtn.removeAttribute('disabled');
          if (this.moduleName === 'messagebox_ordner') {
            const navBox = document.getElementById('leftnav-message-folders');
            const navItem = navBox.querySelector(`#message-folder-name-${id}`);
            navItem.innerHTML = newValue;
          }
        } else {
          msgBox.classList.remove('hidden');
          msgBox.innerHTML = result.message;
        }
      });

      deleteBtn.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        deleteBtn.setAttribute('disabled', 'disabled');
        msgBox.innerHTML = this.deleteMessage.replace(/(%s|%d)/g, $0 => {
          const index = {
            '%s': nameWrapperText.innerText,
            '%d': id
          };
          return index[$0] !== undefined ? index[$0] : $0;
        });
        msgBox.classList.remove('hidden');
      });

      $('body').on('click', '.confirm-delete', e => {
        const elm = e.target || e.srcElement;
        let elID = elm.id;
        if (elm.nodeName === 'I') {
          elID = elm.parentElement.id;
        }
        if (elID === id) {
          item.style.display = 'none'; // eslint-disable-line no-param-reassign
          if (this.moduleName === 'messagebox_ordner') {
            this.deleteMessageFolder(id);
          } else {
            this.deleteAlbum(id);
          }
        }
      });

      cancelBtn.addEventListener('click', () => {
        const newCurrentValue = inputNameCurrent.value.trim();
        item.setAttribute('data-item-name', newCurrentValue);
        nameWrapperText.innerText = newCurrentValue;
        inputName.value = newCurrentValue;
        deleteBtn.removeAttribute('disabled');
        msgBox.classList.add('hidden');
        msgBox.innerHTML = '';
        this.implaceEdit('hide', editBtn, nameWrapper, actionsWrapper);
      });
    });
  }

  createFolder(id, name) {
    const result = {
      error: 0
    };
    if (name.length < 3) {
      result.error = 1;
      result.title = 'errorTitle';
      result.message = this.errorMaxChars;
    } else if (!name.match(/^([a-zA-Z0-9öÖüÜäÄßàÀèÈìÌòÒùÙáÁéÉíÍóÓúÚ' _-]+)$/)) {
      result.error = 2;
      result.title = 'errorTitle';
      result.message = this.errorAllovedChars;
    } else {
      const formular = document.getElementById('create-folder');
      formular.submit();
    }
    return result;
  }

  deleteAlbum(id) {
    const data = {
      mode: 'deleteGalleryAlbum',
      album_id: parseInt(id, 10)
    };
    $.ajax({
      url: '/ajax.php',
      method: 'GET',
      data,
      success: response => {
        if (response.error !== undefined) {
          // eslint-disable-next-line no-alert
          alert('An error is ocurred. Please try again.');
        }
      }
    });
  }

  deleteMessageFolder(id) {
    const date = new Date();
    const time = date.getTime();
    $.post(`messagebox_ordner.php?t=${time}`, {
      ordner: id,
      del: true,
      really_del: true,
      ajaxed: true
    }).always(() => {
      window.location.href = '/messagebox_ordner.php';
    });
  }

  save(id, name) {
    const result = {
      error: 0
    };
    if (name.length < 3) {
      result.error = 1;
      result.title = 'errorTitle';
      result.message = this.errorMaxChars;
    } else if (!name.match(/^([a-zA-Z0-9öÖüÜäÄßàÀèÈìÌòÒùÙáÁéÉíÍóÓúÚ' _-]+)$/)) {
      result.error = 2;
      result.title = 'errorTitle';
      result.message = this.errorAllovedChars;
    } else {
      const scriptUrl = '/ajax.php';
      const data = {};
      data.album_id = id;
      data.album_name = name.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
      if (this.moduleName === 'messagebox_ordner') {
        data.mode = 'renameMessageboxFolder';
      } else {
        data.mode = 'renameGalleryAlbum';
      }
      $.ajax({
        url: scriptUrl,
        method: 'POST',
        data,
        success: response => {
          if (response.error !== undefined) {
            // eslint-disable-next-line no-alert
            alert('An error is ocurred. Please try again.');
          }
        }
      });
    }
    return result;
  }

  /* eslint-disable no-param-reassign */
  implaceEdit(action, editBtn, nameWrapper, actionsWrapper) {
    const tmp = actionsWrapper.querySelector('input[type="text"]');
    switch (action) {
      case 'show':
        // hide text
        nameWrapper.style.display = 'none';
        editBtn.style.display = 'none';
        // show input
        tmp.value = tmp.value.trim();
        actionsWrapper.style.display = '';
        actionsWrapper.querySelector('.action-elements').style.display = '';
        break;
      case 'hide':
      default:
        // show text
        tmp.value.trim();
        nameWrapper.style.display = '';
        editBtn.style.display = '';
        // hide input
        actionsWrapper.style.display = 'none';
        actionsWrapper.querySelector('.action-elements').style.display = 'none';
        break;
    }
  }
  /* eslint-enable no-param-reassign */
  /* eslint-enable class-methods-use-this */
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/folder_manager.js